import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import allocateRunnersService from "services/allocateRunnersService";

// List Allocate Shipping Unit
export const useListAllocateRunner = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["allocateRunner"]);
  const { addToast } = useToasts();

  const { params } = payload;

  return useQuery(
    ["allocate-runner", params?.page],
    () => allocateRunnersService.listAllocateRunner(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
            t("message.list", {
              target: t("allocate_runner"),
              status: t("message.error"),
            }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;

        return {
          items: data.items || [],
          params: params,
          totalCount: data._meta ? data._meta.totalCount : data.items.length,
        };
      },
    }
  );
};

export const useListChangeScheduleByRunner = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["allocateRunner"]);
  const { addToast } = useToasts();

  const { params } = payload;

  return useQuery(
    ["list-change-schedule-by-runner", params?.page],
    () => allocateRunnersService.listChangeScheduleByRunner(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
            t("message.list", {
              target: t("allocate_runner"),
              status: t("message.error"),
            }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;

        return {
          items: data.items || [],
          params: params,
          totalCount: data._meta ? data._meta.totalCount : data.items.length,
        };
      },
    }
  );
};

export const useCreateRunnerScheduleChanges = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["allocateRunner"]);
  const { addToast } = useToasts();

  return useMutation(allocateRunnersService.createRunnerScheduleChanges, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.create", {
          target: "lịch",
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
          t("message.create", {
            target: t("allocate_runner"),
            status: t("message.error"),
          }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useUpdateRunnerScheduleChanges = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["allocateRunner"]);
  const { addToast } = useToasts();

  return useMutation(allocateRunnersService.updateRunnerScheduleChanges, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.update", {
          target: "lịch",
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
          t("message.update", {
            target: t("allocate_runner"),
            status: t("message.error"),
          }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useDeleteRunnerScheduleChanges = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["allocateRunner"]);
  const { addToast } = useToasts();

  return useMutation(allocateRunnersService.deleteRunnerScheduleChanges, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.delete", {
          target: "lịch",
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
          t("message.delete", {
            target: t("allocate_runner"),
            status: t("message.error"),
          }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useChangeRunnerType = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["allocateRunner"]);
  const { addToast } = useToasts();

  return useQuery(
    ["change-runner-type"],
    () => allocateRunnersService.changeRunnerType(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
            t("message.list", {
              target: t("allocate_runner"),
              status: t("message.error"),
            }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return Object.entries(data).map(([k, v]) => {
          return {
            value: k,
            label: v,
          };
        });
      },
    }
  );
};

export const useListRunnerFree = ({
  payload = undefined,
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { t } = useTranslation(["allocateRunner"]);
  const { addToast } = useToasts();

  const { params } = payload;

  return useQuery(
    ["list-runner-free"],
    () => allocateRunnersService.listRunnerFree(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
            t("message.list", {
              target: t("allocate_runner"),
              status: t("message.error"),
            }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return data?.map(item => {
          return {
            value: item.id,
            label: item.display_name,
          };
        });
      },
    }
  );
};

export const useListRunnerCurrent = ({
  payload = undefined,
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { t } = useTranslation(["allocateRunner"]);
  const { addToast } = useToasts();

  return useQuery(
    ["list-runner-current"],
    () => allocateRunnersService.listRunnerCurrent(payload),
    {
      enabled: false,
      retry: 1,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
            t("message.list", {
              target: t("allocate_runner"),
              status: t("message.error"),
            }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return data?.map(item => {
          return {
            value: item.id,
            label: item.display_name,
          };
        });
      },
    }
  );
};

/**
 * @param {{ hubId?: number | null, enabled?: boolean }} [options]
 */
export const useRunnerScheduleWeeksByHub = ({
  hubId,
  enabled = true,
} = {}) => {
  const { t } = useTranslation(["allocateRunner"]);
  const { addToast } = useToasts();

  return useQuery(
    ["runner-schedule-weeks-by-hub", hubId],
    () =>
      allocateRunnersService.getRunnerScheduleWeeksByHub({
        hub_id: hubId,
      }),
    {
      enabled: Boolean(enabled && hubId),
      retry: 1,
      select: response => {
        const body = response?.data;

        if (body?.data && typeof body.data === "object" && !Array.isArray(body.data)) {
          return body.data;
        }

        return body;
      },
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
            t("message.list", {
              target: t("allocate_runner"),
              status: t("message.error"),
            }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
      },
    }
  );
};

export const useClearRunnerScheduleChanges = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["allocateRunner"]);
  const { addToast } = useToasts();

  return useMutation(allocateRunnersService.clearRunnerScheduleChanges, {
    retry: 0,
    onSuccess: res => {
      if (res.data?.result) {
        addToast(
          t("message.clear", {
            target: "lịch phân bổ runner",
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
      } else {
        addToast(
          formConvertErrorMessage(
            res.data?.message ||
            t("message.clear", {
              target: "lịch phân bổ runner",
              status: t("message.error"),
            }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(res.data);
        }
      }
      if (typeof onSuccess === "function") {
        onSuccess(res);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
          t("message.clear", {
            target: "lịch phân bổ runner",
            status: t("message.error"),
          }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};
